import React from 'react'
import MasterLayout from 'views/MasterLayout'
import PeopleRouter from './Router'

export default function PeopleLayout(props) {
  return (
    <MasterLayout>
      <PeopleRouter match={props.match} />
    </MasterLayout>
  )
}
